import React from 'react';

import { linkResolver } from '@prismic/prismic-config';
import email from 'images/contact-widget/email-widget.svg';
import help from 'images/contact-widget/help-widget.svg';
import messenger from 'images/contact-widget/messenger-widget.svg';
import phone from 'images/contact-widget/phone-widget.svg';
import whatsapp from 'images/contact-widget/whatsapp-widget.svg';

import * as S from './styles';
import { IProps } from './types';

export const ContactsList: React.FC<IProps> = ({ layout }) => (
  <>
    {layout?.contact?.map((c, i) => (
      <S.LinkWrapper
        href={linkResolver(c.link)}
        icon={c.type}
        target="_blank"
        rel="noreferrer"
      >
        <S.IconWrapper icon={c.type}>
          <>
            {c.type === 'phone' && <img src={phone} alt="phone" />}
            {c.type === 'help' && <img src={help} alt="help" />}
            {c.type === 'email' && <img src={email} alt="email" />}
            {c.type === 'messenger' && <img src={messenger} alt="messenger" />}
            {c.type === 'whatsapp' && <img src={whatsapp} alt="whatsapp" />}
          </>
        </S.IconWrapper>
        <S.Text>
          {c.type === 'phone' || c.type === 'email' ? (
            <>
              {c.type}
              <S.Hint>{c.label}</S.Hint>
            </>
          ) : (
            <>{c.label}</>
          )}
        </S.Text>
      </S.LinkWrapper>
    ))}
  </>
);
